import { render, staticRenderFns } from "./ClientRecurrence.vue?vue&type=template&id=670dd6d4&scoped=true"
import script from "./ClientRecurrence.vue?vue&type=script&lang=js"
export * from "./ClientRecurrence.vue?vue&type=script&lang=js"
import style0 from "./ClientRecurrence.vue?vue&type=style&index=0&id=670dd6d4&prod&scoped=true&lang=css"
import style1 from "./ClientRecurrence.vue?vue&type=style&index=1&id=670dd6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670dd6d4",
  null
  
)

export default component.exports